import { BlackFridayBanner } from '../components/banner/BlackFridayBanner';
// Future: import ChristmasBanner from "../components/banner/ChristmasBanner";
// Future: import NewYearBanner from "../components/banner/NewYearBanner";

export interface BannerComponentProps {
  maxDiscount: number;
  redirectPath: string;
  onClose?: () => void;
}

export const BANNER_REGISTRY = {
  blackfriday25: BlackFridayBanner,
  // Future: christmas25: ChristmasBanner,
  // Future: newyear25: NewYearBanner,
} as const;

export type BannerEvent = keyof typeof BANNER_REGISTRY;
